import { useTimeZoneControl, zoneAbbrev, zoneLabel } from './timezone-context';

/**
 * Header timezone picker — doubles as the single on-screen indicator of which
 * zone every date in the app is rendered in. Matches the raw-`<select>`
 * convention used elsewhere in the TopBar.
 */
export function TimeZoneSelect() {
  const { timeZone, setTimeZone, options } = useTimeZoneControl();
  const abbrev = zoneAbbrev(timeZone);

  return (
    <label className="flex items-center gap-1 text-xs text-gray-600" title="Timezone all dates are shown in">
      <span className="hidden sm:inline">Times in</span>
      <select
        value={timeZone}
        onChange={(e) => setTimeZone(e.target.value)}
        className="rounded border border-gray-300 bg-white px-2 py-1 text-xs font-medium text-gray-800"
        aria-label="Display timezone"
      >
        {options.map((tz) => (
          <option key={tz} value={tz}>
            {zoneLabel(tz)}
            {zoneAbbrev(tz) ? ` (${zoneAbbrev(tz)})` : ''}
          </option>
        ))}
      </select>
      {abbrev && <span className="sr-only">Currently {abbrev}</span>}
    </label>
  );
}
